/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : DocumentLibraryCard.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import CustomButtonV2 from "../../../components/customComponentsV2/common/button/CustomButtonV2";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { componentStyle } from "../../../config/appTheme";
import CustomToolTip from "../../../components/infoButton/CustomToolTip";
function DocumentLibraryCard({
  name,
  moduleType,
  documentType,
  attachmentType,
  handleOpen,
  data,
}) {
  return (
    <Box
      sx={{
        p: 2,
        height: "18rem",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        border: "1px solid gray",
        width: "13rem",
        backgroundColor: "#fff",
        position: "relative",
        transition: "transform 0.25s ease, box-shadow 0.25s ease",
      }}
    >
      <Box

        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <CustomButtonV2
          btnName={"View"}
          handleOnClick={() => handleOpen(data)}
        />
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "90px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <VisibilityOffIcon />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "left",
          p: 2,
          alignItems: "flex-start",
          minHeight: "3.5em",
        }}
      >
        <CustomToolTip
          length={50}
          style={{
            ...componentStyle.font.cardText,
            textAlign: "left",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: 1.2,
          }}
        >
          {name}
        </CustomToolTip>
      </Box>
      <Box sx={{ width: "50%", borderBottom: "1px solid black", ml: 2 }}></Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "left",
          px: 2,
          pt: 1,
          pb: 0.5,
          gap: 0.5,
        }}
      >
        {moduleType ? (
          <Typography
            sx={{
              ...componentStyle.font.text,
              fontSize: "13px",
              fontWeight: 600,
              color: "#212121",
              lineHeight: 1.2,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={moduleType}
          >
            {moduleType}
          </Typography>
        ) : null}
        {documentType ? (
          <Typography
            sx={{
              ...componentStyle.font.tableText,
              fontSize: "12px",
              fontWeight: 400,
              color: "#616161",
              lineHeight: 1.2,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={documentType}
          >
            {documentType}
          </Typography>
        ) : null}
        {attachmentType ? (
          <Typography
            sx={{
              ...componentStyle.font.tableText,
              fontSize: "11px",
              fontWeight: 500,
              color: "#757575",
              lineHeight: 1.2,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={attachmentType}
          >
            {attachmentType}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
}

DocumentLibraryCard.propTypes = {
  name: PropTypes.string,
  moduleType: PropTypes.string,
  documentType: PropTypes.string,
  attachmentType: PropTypes.string,
  handleOpen: PropTypes.func,
  data: PropTypes.object,
};

export default DocumentLibraryCard;
